import { AxiosInstance } from 'axios';

export type UploaderSlot = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 'dsu';

export interface PublicUploaderFileItem {
  fileName: string;
  size: number;
  mtimeMs: number;
  url: string;
}

export default class PublicUploaderService {
  constructor(private axios: AxiosInstance) {}

  list = async (slot: UploaderSlot): Promise<{ slot: UploaderSlot; files: PublicUploaderFileItem[] }> => {
    const body: any = await this.axios.get(`public-uploader/${slot}/files`);
    return body.data;
  };

  upload = async (slot: UploaderSlot, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const body: any = await this.axios.post(`public-uploader/${slot}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return body.data;
  };

  deleteFile = async (slot: UploaderSlot, fileName: string): Promise<{ success: boolean; message?: string }> => {
    const body: any = await this.axios.delete(`public-uploader/${slot}/files`, {
      params: { fileName },
    });
    return body.data;
  };
}
